<template>
    <PageGroup>
        <router-view :key="$route.path" />
    </PageGroup>
</template>

<script>
    import PageGroup from 'source/components/_generics/layouts/PageGroup.vue';

    export default {
        name: 'FormsPageGroup',

        components: { PageGroup },


        eventBusCallbacks: {
            'open-forms-toast': 'openFormsToastHandler',
        },

        methods: {
            openFormsToastHandler(args) {
                const actionArgs = {
                    actionLabel: 'View',
                    actionEvent: { name: 'toast-view-form', payload: { pk: args?.pk } }
                };
                const successArgs = {
                    form_created: { label: 'Form created', ...actionArgs },
                    form_updated: { label: 'Form updated',
                                    ...(!!args?.no_callback ? {} : actionArgs)
                    },
                    form_archived: { label: 'Form archived' },
                    form_restored: { label: 'Form restored' }
                };
                const errorArgs = {
                    isError: true,
                    label: 'Something went wrong. Please try again.'
                };

                this.$eventBus.$emit(
                    'trigger-toast', args?.status === 'error' ? errorArgs : successArgs[args?.action]
                );
            },
        }
    };

</script>
